<template>
    <div class="fm-container">
        <Backer />

        <div style="font-size: 25px; display: inline-block; margin: 10px; font-weight: bold; text-align: center; width: 100%;">Lookup Product</div>

        <div class="fm-container">

            <div>
                <b-form @submit="lookupProducts">
                    <span style="margin: 10px;">Search Product (SKU / Product Name / ID):</span>
                    <div style="margin: 10px;">
                        <b-form-input autocomplete="off" type="text" style="width: 300px; display: inline-block;" v-model="search_query"></b-form-input>

                        <b-button style="display: inline-block; margin-left: 5px;" type="submit" variant="success" :disabled="disable_all_actions">Submit</b-button>
                    </div>
                </b-form>
            </div>

            <b-overlay :show="products_data_being_loaded" rounded="sm" style="margin-top: 20px;">
                <div v-if="products.length > 0" >
                    
                    <table style="width: 100%">
                        <thead>
                            <tr style="background: black; color: white; font-weight: bold;">
                                <td class="ipt_tdhr">
                                    ID
                                </td>
                                <td class="ipt_tdhr">
                                    SKU
                                </td>
                                <td class="ipt_tdhr">
                                    NAME
                                </td>
                                <td class="ipt_tdhr">
                                    VENDOR
                                </td>
                                <td class="ipt_tdhr">
                                    CATEGORY
                                </td>
                                <td class="ipt_tdhr">
                                    SELLING PRICE
                                </td>
                                <td class="ipt_tdhr" v-if="userDetails.userrole == 'admin'">
                                    LANDED COST
                                </td>
                                <td class="ipt_tdhr" v-if="userDetails.userrole == 'admin'">
                                    WHOLESALE PRICE
                                </td>
                                <td class="ipt_tdhr">
                                    ACTIONS
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product, idx in products">
                                <td class="ipt_tdr">
                                    {{ product.id }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ product.sku }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ product.product_name }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ product.vendor }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ product.category }}
                                </td>
                                <td class="ipt_tdr">
                                    ${{ product.selling_price }}
                                </td>
                                <td class="ipt_tdr" v-if="userDetails.userrole == 'admin'">
                                    ${{ product.landed_cost }}
                                </td>
                                <td class="ipt_tdr" v-if="userDetails.userrole == 'admin'">
                                    ${{ product.wholesale_price }}
                                </td>
                                <td class="ipt_tdr">
                                    <b-button size="sm" variant="dark" :disabled="disable_all_actions" @click="getItemAvailability(idx)">Availability</b-button>

                                    <b-button size="sm" variant="success" :disabled="disable_all_actions" @click="generateQRCode(idx)">QR Code</b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-overlay>

            <b-modal id="modal-availability" scrollable title="" size="md" hide-footer>
                <Availability :viewdata="{availability_data:availability_data, product_id: q_product_id, product_sku: q_product_sku}" :locationsdict="locationsdict" :sublocationsdict="sublocationsdict" />
            </b-modal>

            <b-modal id="modal-qr-generator" scrollable title="" size="xl" hide-footer>
                <QRGenerator :product="qr_data" :locationsdict="locationsdict" :sublocationsdict="sublocationsdict" />
            </b-modal>
        </div>

    </div>

</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import Availability from '@/components/importables/Availability'
    import QRGenerator from '@/components/importables/QRGenerator'

    export default {
        name: "LookupProduct",
        components: {
            Backer,
            Availability,
            QRGenerator
        },
        data: function(){
            let out = {
                userDetails: {properties: {}},
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                search_query: null,
                products_data_being_loaded: false,
                disable_all_actions: false,
                products: [],
                q_product_sku: null,
                q_product_id: null,
                availability_data: [],
                qr_data: {},
            };
            return out;
        },
        methods: {
            isAdmin: function(){
                if (this.userDetails.userrole == 'admin'){
                    return true
                }
                else {
                    return false
                }
            },
            lookupProducts: function(e){
                if (e){
                    e.preventDefault();
                }

                if (!this.search_query || (this.search_query || "").length < 3) {
                    this.$bvToast.toast(
                        "Search queries should be specific (at least 3 characters long).", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    ); 
                    return
                }

                let path = "/api/product/fuzzy_lookup_product/"
                let data = {search_query: this.search_query}
                let that = this;

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        ); 
                    }
                    else {
                        that.products = response.data.result;
                    }
                    that.disable_all_actions = false;
                    that.products_data_being_loaded = false;
                }
                
                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading products.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.disable_all_actions = false;
                    that.products_data_being_loaded = false;
                }

                this.disable_all_actions = true;
                this.products_data_being_loaded = true;
                Requestor.getSync(path, data, s, f);
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/location/list_locations/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name}
                                });
                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/location/list_sublocations/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response){
                            if (response.data.result){
                                that.sublocations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading sublocations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            getItemAvailability: function(idx){
                let path = "/api/inventory/get_tr_item_availability/";
                let item = this.products[idx];
                let data = {product_id: item.id, product_sku: item.sku};
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.availability_data = response.data.result;
                        that.q_product_id = item.id;
                        that.q_product_sku = item.sku;
                        that.$bvModal.show("modal-availability");
                    }
                    that.disable_all_actions = false
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "An error occurred trying to fetch product availability. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.disable_all_actions = false;
                }
                this.disable_all_actions = true;
                Requestor.getAsync(path, data, s, f);
            },
            generateQRCode: function(idx){
                console.log(idx);
                let item = this.products[idx];;
                this.qr_data = {product_id: item.id, product_sku: item.sku};

                this.$bvModal.show("modal-qr-generator");
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.fetch_prereqs();
            }
        }
    }
</script>

<style scoped>
    .new_tr_label_box {
        display: inline-block;
        margin: 10px;
        width: auto;
        border: 1px solid;
        padding: 5px;
        font-size: 14px;
        background: #e5ffb1;
    }

    .tr_div {
        background: #efefef;
        border: 1px solid;
        margin-bottom: 37px;
    }

    td {
        padding: 3px;
        font-size: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/LookupProduct.vue